(function(){
  'use strict';

  const normalize = (v) => (v == null ? '' : String(v)).replace(/\s+/g,' ').trim().toLowerCase();
  const SIZE_SET = new Set(['pp','p','m','g','gg','xg','xxg']);

  function parseMap(raw){
    const out = {};
    if (!raw) return out;
    String(raw).replace(/,/g,';').split(';').map(s=>s.trim()).filter(Boolean).forEach(pair=>{
      const p = pair.split('=').map(x=>(x||'').trim());
      if (p.length < 2) return;
      const k = parseInt(p[0],10);
      const v = p.slice(1).join('=');
      if (!k) return;
      out[k] = v;
    });
    return out;
  }

  function parseUnitPriceToCents(v){
    const s = String(v||'').trim().replace(/\./g,'').replace(',', '.');
    const n = Number(s);
    if (!Number.isFinite(n)) return null;
    return Math.round(n * 100);
  }

  function formatMoney(cents, moneyFormat, currency){
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    try {
      return new Intl.NumberFormat('pt-BR', { style:'currency', currency: currency || 'BRL' }).format((cents||0)/100);
    } catch(e){
      return (cents/100).toFixed(2);
    }
  }

  function getCartAddJsUrl(){
    const base = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ? window.theme.routes.cart_add_url : '/cart/add';
    const clean = String(base).split('?')[0];
    if (clean.endsWith('.js')) return clean;
    if (clean.endsWith('/cart/add')) return clean + '.js';
    if (clean.endsWith('/add')) return clean + '.js';
    return '/cart/add.js';
  }

  async function cartAdd(items){
    const url = getCartAddJsUrl();

    const res = await fetch(url, {
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'X-Requested-With':'XMLHttpRequest',
        'Accept':'application/json'
      },
      body: JSON.stringify({ items }),
      credentials: 'same-origin'
    });

    if (!res.ok) {
      let msg = `HTTP ${res.status}`;
      try {
        const j = await res.json();
        msg = j?.description || j?.message || msg;
      } catch(e){
        try {
          const t = await res.text();
          if (t && t.length < 300) msg = t;
        } catch(e2){}

      }
      throw new Error(msg);
    }
    return res.json();
  }

  // ✅ CUPOM AUTOMÁTICO
  async function applyDiscountCode(code){
    if (!code) return;
    try{
      await fetch(`/discount/${encodeURIComponent(code)}`, {
        method:'GET',
        credentials:'same-origin'
      });
    }catch(e){ }
  }

  function openCartDrawerSafe(){
    if (window.cart && typeof window.cart.open === 'function') { window.cart.open(); return true; }
    const opener =
      document.querySelector('[data-cart-drawer-open]') ||
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('button[name="open-cart"]');
    if (opener) { opener.click(); return true; }
    return false;
  }

  function inferTierFromPath(pathname, allowedSet){
    const p = (pathname || '').toLowerCase();
    const m =
      p.match(/(?:^|[-\/])(\d+)-unidades?(?:$|[-\/])/i) ||
      p.match(/(?:^|[-\/])(\d+)\s*unidades?(?:$|[-\/])/i);

    if (m && m[1]) {
      const n = parseInt(m[1], 10);
      if (allowedSet.has(n)) return n;
    }

    const nums = p.match(/\d+/g) || [];
    for (const s of nums) {
      const n = parseInt(s, 10);
      if (allowedSet.has(n)) return n;
    }
    return null;
  }

  function initOne(root){
    if (!root || root.dataset.vexTierkitInit === '1') return;
    root.dataset.vexTierkitInit = '1';

    const jsonEl = root.querySelector('[data-tierkit-json]');
    if (!jsonEl) return;

    let data;
    try { data = JSON.parse(jsonEl.textContent); } catch(e){ return; }

    const moneyFormat = data.moneyFormat || "{{amount}}";
    const currency = data.currency || 'BRL';

    const tierBtns = [...root.querySelectorAll('[data-tier]')];
    if (!tierBtns.length) return;

    const singleBlock   = root.querySelector('[data-single]');
    const singleCTA     = root.querySelector('[data-single-cta]');
    const singleBuy     = root.querySelector('[data-single-buy]');
    const singleLoading = root.querySelector('[data-single-loading]');
    const singleError   = root.querySelector('[data-single-error]');

    const gradeWrap     = root.querySelector('[data-grade]');
    const gradeTotalEl  = root.querySelector('[data-grade-total]');
    const gradeLimitEl  = root.querySelector('[data-grade-limit]');
    const gradeStatusEl = root.querySelector('[data-grade-status]');
    const gradeCTA      = root.querySelector('[data-grade-cta]');
    const gradeBuy      = root.querySelector('[data-grade-buy]');
    const gradeLoading  = root.querySelector('[data-grade-loading]');
    const gradeError    = root.querySelector('[data-grade-error]');

    const cols = [...root.querySelectorAll('[data-size]')];
    const vars = data.variants || [];

    // visual: unit prices
    const unitPricesMapRaw = parseMap(data.unitPricesRaw || '');
    const unitPricesCents = {};
    Object.keys(unitPricesMapRaw).forEach(k=>{
      const qty = parseInt(k,10);
      const cents = parseUnitPriceToCents(unitPricesMapRaw[k]);
      if (qty && cents != null) unitPricesCents[qty] = cents;
    });

    // ✅ mapa de cupons por tier (metafield NOVO)
    const discountCodesMap = parseMap(data.discountMapRaw || '');

    // detect size idx
    let hasSizes = !!data.hasSizes;
    let sizeIdx = (Number(data.sizeOptionPos||0) > 0) ? (Number(data.sizeOptionPos) - 1) : 0;

    if (vars.length) {
      const optCount = (vars[0].options || []).length;
      let bestIdx = -1;
      let bestHits = 0;

      for (let i=0;i<optCount;i++){
        const found = new Set();
        for (const v of vars){
          const val = normalize((v.options || [])[i]);
          if (SIZE_SET.has(val)) found.add(val);
        }
        if (found.size > bestHits){
          bestHits = found.size;
          bestIdx = i;
        }
      }
      if (bestIdx >= 0 && bestHits >= 2){
        sizeIdx = bestIdx;
        hasSizes = true;
      }
    }

    if (cols.length < 2) hasSizes = false;

    const tierNumbers = tierBtns.map(b=>Number(b.dataset.tier||0)).filter(n=>n>0);
    const maxTier = tierNumbers.length ? Math.max(...tierNumbers) : 0;

    const state = {
      tier: Number(tierBtns[0].dataset.tier || 1),
      limit: Number(tierBtns[0].dataset.tier || 1),
      qtyBySize: {},
      maxBySize: {}
    };

    function showError(el, msg){
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      setTimeout(()=>{ el.hidden = true; }, 4500);
    }

    function setLoading(btn, loadingEl, on){
      if (!btn || !loadingEl) return;
      loadingEl.hidden = !on;
      btn.disabled = !!on;
    }

    function baseUnitPriceCents(){
      const mf = Number(data.baseUnitPrice || 0);
      if (mf > 0) return Math.round(mf * 100);
      return (vars.find(v=>v.available) || vars[0])?.price ?? 0;
    }

    function getMaxForVariant(v){
      let max = Infinity;

      if (v && v.inventory_management === 'shopify' && v.inventory_policy !== 'continue') {
        const stock = Number(v.inventory_quantity);
        max = Number.isFinite(stock) ? Math.max(0, stock) : 0;
      }

      const qmax = v && v.qty_rule_max;
      if (qmax !== null && qmax !== undefined && qmax !== '' && Number.isFinite(Number(qmax))) {
        max = Math.min(max, Number(qmax));
      }

      return max;
    }

    let otherVary = false;
    if (vars.length) {
      const optCount = (vars[0].options || []).length;
      for (let i=0;i<optCount;i++){
        if (i === sizeIdx) continue;
        const s = new Set();
        for (const v of vars) s.add(normalize((v.options||[])[i]));
        if (s.size > 1) { otherVary = true; break; }
      }
    }

    function resolveVariantForSize(sizeValue){
      const wanted = normalize(sizeValue);

      if (!otherVary) {
        const avail = vars.find(v => v.available && normalize((v.options||[])[sizeIdx]) === wanted);
        const any   = vars.find(v => normalize((v.options||[])[sizeIdx]) === wanted);
        return avail || any || null;
      }

      const avail = vars.find(v => v.available && normalize((v.options||[])[sizeIdx]) === wanted);
      const any   = vars.find(v => normalize((v.options||[])[sizeIdx]) === wanted);
      return avail || any || null;
    }

    function resetGrade(){
      state.qtyBySize = {};
      cols.forEach(col=>{
        const key = normalize(col.dataset.size || '');
        state.qtyBySize[key] = 0;
        const input = col.querySelector('[data-qty]');
        if (input) input.value = '0';
      });
    }

    function getTotal(){
      let sum = 0;
      Object.values(state.qtyBySize).forEach(v=> sum += Number(v)||0);
      return sum;
    }

    function clampValue(key, currentCellValue, nextCellValue){
      const total = getTotal();
      const current = Number(currentCellValue) || 0;

      const remaining = state.limit - (total - current);
      const maxSize = Number.isFinite(state.maxBySize[key]) ? state.maxBySize[key] : Infinity;

      return Math.max(0, Math.min(Number(nextCellValue)||0, Math.max(0, remaining), maxSize));
    }

    function updateGradeAvailability(){
      cols.forEach(col=>{
        const sizeVal = col.dataset.size || '';
        const key = normalize(sizeVal);
        const variant = resolveVariantForSize(sizeVal);

        const soldout = col.querySelector('[data-soldout]');
        const plus = col.querySelector('[data-pm="plus"]');
        const minus = col.querySelector('[data-pm="minus"]');
        const input = col.querySelector('[data-qty]');

        const maxQty = variant ? getMaxForVariant(variant) : 0;
        state.maxBySize[key] = Number.isFinite(maxQty) ? maxQty : Infinity;

        const isAvailable = !!variant && !!variant.available && maxQty > 0;

        if (!isAvailable) {
          col.classList.add('is-disabled');
          if (soldout) soldout.hidden = false;
          if (plus) plus.disabled = true;
          if (minus) minus.disabled = true;
          if (input) input.disabled = true;

          state.qtyBySize[key] = 0;
          if (input) input.value = '0';
        } else {
          col.classList.remove('is-disabled');
          if (soldout) soldout.hidden = true;
          if (plus) plus.disabled = false;
          if (minus) minus.disabled = false;
          if (input) input.disabled = false;

          const cur = Number(state.qtyBySize[key] || 0);
          if (cur > maxQty) {
            state.qtyBySize[key] = maxQty;
            if (input) input.value = String(maxQty);
          }
        }
      });
    }

    function updateGradeUI(){
      const total = getTotal();
      if (gradeTotalEl) gradeTotalEl.textContent = String(total);
      if (gradeLimitEl) gradeLimitEl.textContent = String(state.limit);

      if (gradeStatusEl) {
        if (total < state.limit) gradeStatusEl.textContent = `Faltam ${state.limit - total} unidade(s)`;
        else if (total === state.limit) gradeStatusEl.textContent = 'Perfeito! Kit completo';
        else gradeStatusEl.textContent = 'Ajuste as quantidades';
      }

      const ok = (total === state.limit);
      if (gradeCTA) gradeCTA.disabled = !ok;
      if (gradeBuy) gradeBuy.disabled = !ok;
    }

    function markActiveTier(btn){
      tierBtns.forEach(b=>{
        const active = b===btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    function showGrade(shouldShow){
      if (gradeWrap) gradeWrap.hidden = !shouldShow;
      if (singleBlock) singleBlock.hidden = !!shouldShow;
    }

    function updateTierCards(){
      const baseUnit = baseUnitPriceCents();

      tierBtns.forEach(btn=>{
        const qty = Number(btn.dataset.tier || 1);

        const oldEl = btn.querySelector('[data-price-old]');
        const prefixEl = btn.querySelector('[data-price-prefix]');
        const newEl = btn.querySelector('[data-price-new]');
        const unitEl = btn.querySelector('[data-price-unit]');
        const econEl = btn.querySelector('[data-economy]');
        const bestEl = btn.querySelector('[data-best]');

        if (!newEl || !unitEl) return;

        if (bestEl) bestEl.hidden = !(qty === maxTier && qty > 1);

        const oldTotal = baseUnit * qty;
        const overrideUnit = unitPricesCents[qty] != null ? unitPricesCents[qty] : null;
        const hasDiscount = (overrideUnit != null && overrideUnit > 0 && overrideUnit < baseUnit);

        btn.classList.toggle('has-discount', hasDiscount);

        if (hasDiscount) {
          const newTotal = overrideUnit * qty;

          if (oldEl) { oldEl.hidden = false; oldEl.textContent = `De: ${formatMoney(oldTotal, moneyFormat, currency)}`; }
          if (prefixEl) prefixEl.hidden = false;

          newEl.textContent = formatMoney(newTotal, moneyFormat, currency);
          unitEl.textContent = `${formatMoney(overrideUnit, moneyFormat, currency)} (un)`;

          if (econEl) {
            econEl.hidden = false;
            econEl.textContent = `Economia de ${formatMoney(oldTotal - newTotal, moneyFormat, currency)}`;
          }
        } else {
          if (oldEl) { oldEl.hidden = true; oldEl.textContent = ''; }
          if (prefixEl) prefixEl.hidden = true;

          newEl.textContent = formatMoney(oldTotal, moneyFormat, currency);
          unitEl.textContent = qty === 1 ? '' : `${formatMoney(baseUnit, moneyFormat, currency)} (un)`;

          if (econEl) { econEl.hidden = true; econEl.textContent = ''; }
        }
      });
    }

    // ===== CUPOM helper por tier =====
    function getTierDiscountCode(){
      const c = discountCodesMap[state.tier] || '';
      return String(c || '').trim();
    }

    // ===== INIT (tier pela URL se existir número) =====
    const allowed = new Set(tierBtns.map(b => Number(b.dataset.tier || 0)).filter(n => n > 0));
    const inferred = inferTierFromPath(window.location.pathname, allowed);

    const initialTier = (inferred != null) ? inferred : Number(tierBtns[0].dataset.tier || 1);
    const initialBtn = tierBtns.find(b => Number(b.dataset.tier) === initialTier) || tierBtns[0];

    state.tier = initialTier;
    markActiveTier(initialBtn);

    if (hasSizes) {
      state.limit = initialTier; // ✅ tier 1 também abre grade (limit 1)
      resetGrade();
      updateGradeAvailability();
      showGrade(true);
      updateGradeUI();
    } else {
      showGrade(false);
    }

    // clique tiers (SEM redirect)
    tierBtns.forEach(btn=>{
      btn.addEventListener('click', (e)=>{
        e.preventDefault();

        const qty = Number(btn.dataset.tier || 1);
        state.tier = qty;
        markActiveTier(btn);

        if (hasSizes) {
          state.limit = qty;
          resetGrade();
          updateGradeAvailability();
          showGrade(true);
          updateGradeUI();
        } else {
          showGrade(false);
        }
      });
    });

    // grade +/-
    root.addEventListener('click', (e)=>{
      const pm = e.target.closest('[data-pm]');
      if (!pm) return;

      const col = pm.closest('[data-size]');
      if (!col || col.classList.contains('is-disabled')) return;

      const input = col.querySelector('[data-qty]');
      if (!input || input.disabled) return;

      const key = normalize(col.dataset.size || '');
      let current = parseInt(input.value || '0', 10);
      if (Number.isNaN(current)) current = 0;

      let next = current + (pm.dataset.pm === 'plus' ? 1 : -1);
      next = Math.max(0, next);

      const fixed = clampValue(key, current, next);
      input.value = String(fixed);
      state.qtyBySize[key] = fixed;
      updateGradeUI();
    });

    root.addEventListener('input', (e)=>{
      const input = e.target.closest('[data-qty]');
      if (!input) return;

      const col = input.closest('[data-size]');
      if (!col || col.classList.contains('is-disabled')) return;

      const key = normalize(col.dataset.size || '');
      let raw = String(input.value || '').replace(/[^\d]/g,'');
      if (raw === '') raw = '0';

      let next = parseInt(raw, 10);
      if (Number.isNaN(next)) next = 0;

      const current = Number(state.qtyBySize[key] || 0);
      const fixed = clampValue(key, current, next);
      input.value = String(fixed);
      state.qtyBySize[key] = fixed;
      updateGradeUI();
    });

    // CTA SINGLE (produto sem tamanhos)
    if (singleCTA) {
      singleCTA.addEventListener('click', async (e)=>{
        e.preventDefault();
        setLoading(singleCTA, singleLoading, true);

        try {
          const base = (vars.find(v=>v.available) || vars[0]);
          if (!base || !base.available) throw new Error('Produto indisponível.');

          const qtyToAdd = state.tier;
          await cartAdd([{ id: base.id, quantity: qtyToAdd }]);

          const code = getTierDiscountCode();
          if (code) await applyDiscountCode(code);

          openCartDrawerSafe();
        } catch(err){
          showError(singleError, err.message || 'Erro ao adicionar.');
        } finally {
          setLoading(singleCTA, singleLoading, false);
        }
      });
    }

    if (singleBuy) {
      singleBuy.addEventListener('click', async (e)=>{
        e.preventDefault();
        try {
          const base = (vars.find(v=>v.available) || vars[0]);
          if (!base || !base.available) throw new Error('Produto indisponível.');

          const qtyToAdd = state.tier;
          await cartAdd([{ id: base.id, quantity: qtyToAdd }]);

          const code = getTierDiscountCode();
          if (code) window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
          else window.location.href = '/checkout';

        } catch(err){
          showError(singleError, err.message || 'Erro ao finalizar.');
        }
      });
    }

    // CTA GRADE (produto com tamanhos)
    if (gradeCTA) {
      gradeCTA.addEventListener('click', async (e)=>{
        e.preventDefault();
        setLoading(gradeCTA, gradeLoading, true);

        try {
          const total = getTotal();
          if (total !== state.limit) throw new Error(`Complete exatamente ${state.limit} unidades.`);

          const items = [];
          cols.forEach(col=>{
            const sizeVal = col.dataset.size || '';
            const key = normalize(sizeVal);
            const qty = Number(state.qtyBySize[key] || 0);
            if (!qty) return;

            const variant = resolveVariantForSize(sizeVal);
            if (!variant || !variant.available) return;

            const max = getMaxForVariant(variant);
            if (qty > max) throw new Error(`Sem estoque suficiente no tamanho "${sizeVal}".`);

            items.push({ id: variant.id, quantity: qty });
          });

          if (!items.length) throw new Error('Nenhum item selecionado.');

          await cartAdd(items);

          const code = getTierDiscountCode();
          if (code) await applyDiscountCode(code);

          openCartDrawerSafe();
        } catch(err){
          showError(gradeError, err.message || 'Erro ao adicionar.');
        } finally {
          setLoading(gradeCTA, gradeLoading, false);
        }
      });
    }

    if (gradeBuy) {
      gradeBuy.addEventListener('click', async (e)=>{
        e.preventDefault();
        try {
          const total = getTotal();
          if (total !== state.limit) throw new Error(`Complete exatamente ${state.limit} unidades.`);

          const items = [];
          cols.forEach(col=>{
            const sizeVal = col.dataset.size || '';
            const key = normalize(sizeVal);
            const qty = Number(state.qtyBySize[key] || 0);
            if (!qty) return;

            const variant = resolveVariantForSize(sizeVal);
            if (!variant || !variant.available) return;

            const max = getMaxForVariant(variant);
            if (qty > max) throw new Error(`Sem estoque suficiente no tamanho "${sizeVal}".`);

            items.push({ id: variant.id, quantity: qty });
          });

          if (!items.length) throw new Error('Nenhum item selecionado.');

          await cartAdd(items);

          const code = getTierDiscountCode();
          if (code) window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
          else window.location.href = '/checkout';

        } catch(err){
          showError(gradeError, err.message || 'Erro ao finalizar.');
        }
      });
    }

    updateTierCards();
  }

  function initAll(){
    document.querySelectorAll('[data-vex-tierkit]').forEach(initOne);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();